import {LatLng} from 'leaflet';
import {useState} from 'react';
import {MapContainer, Marker, TileLayer, useMapEvents} from 'react-leaflet';
import L from 'leaflet';

type TLocationMapProps = {
  center?: ILocation;
  selectLocation: React.Dispatch<React.SetStateAction<ILocation | undefined>>;
};

const iconPerson = new L.Icon({
  iconUrl: require('../../assets/image/dashboard/icon_location.png'),
  iconRetinaUrl: require('../../assets/image/dashboard/icon_location.png'),
  iconSize: new L.Point(60, 75),
  className: '',
});

export {iconPerson};

function LocationMarker({selectLocation, center}: TLocationMapProps) {
  const [position, setPosition] = useState<LatLng>({
    lat: center?.lat || 0,
    lng: center?.lng || 0,
  } as LatLng);
  const map = useMapEvents({
    click(e) {
      setPosition(e.latlng);
      selectLocation(e.latlng);
      map.flyTo(e.latlng, map.getZoom());
    },
  });

  return position === undefined ? null : (
    <Marker position={position} icon={iconPerson}></Marker>
  );
}

const LocationMap = ({center, selectLocation}: TLocationMapProps) => {
  return (
    <>
      <MapContainer
        attributionControl={false}
        zoomControl={true}
        doubleClickZoom={false}
        scrollWheelZoom={true}
        id={'map'}
        zoom={16}
        center={center}
        style={{width: '100%', height: '192px'}}
        easeLinearity={0.35}
      >
        <TileLayer url="http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}" />
        <LocationMarker center={center} selectLocation={selectLocation} />
      </MapContainer>
    </>
  );
};

export default LocationMap;
